import { Table } from '@statsbomb/kitbag-components';
import { VideoStatus } from '@statsbomb/parachute-types';
import { noop } from 'lodash';
import { TeamGameVideosMenu } from '../games/TeamGameVideosMenu';
import { GameWatchButtonWithFlyout } from '../video/GameWatchButtonWithFlyout';
import { NoVideoLicenceTooltip } from '../video/NoVideoLicenceTooltip';

interface TeamGameWatchCellProps {
  gameId: number;
  gameTotalGoals: number;
  videoStatus: VideoStatus;
  isMenuOpen: boolean;
  onMenuOpen: () => void;
  onMenuClose: () => void;
}

export const TeamGameWatchCell = ({
  gameId,
  gameTotalGoals,
  videoStatus,
  isMenuOpen,
  onMenuOpen,
  onMenuClose,
}: TeamGameWatchCellProps) => (
  <Table.DataCell>
    {videoStatus === 'enabled' ? (
      <GameWatchButtonWithFlyout onClickHandler={onMenuOpen} onOutsideClickHandler={onMenuClose} isOpen={isMenuOpen}>
        <TeamGameVideosMenu gameId={gameId} gameTotalGoals={gameTotalGoals} />
      </GameWatchButtonWithFlyout>
    ) : (
      <NoVideoLicenceTooltip videoStatus={videoStatus}>
        <GameWatchButtonWithFlyout onClickHandler={noop} onOutsideClickHandler={noop} isOpen={false} isDisabled>
          <span />
        </GameWatchButtonWithFlyout>
      </NoVideoLicenceTooltip>
    )}
  </Table.DataCell>
);
